/**
 * 医生排班模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 新增排班
export const scheduleAdd = (params) => {
  return req.post('/scheduling/item', params);
}

// 修改排班信息
export const scheduleEdit = (params) => {
  return req.put('/scheduling/item', params);
}

// 获取排班列表
export const scheduleList = (params) => {
  return req.get('/scheduling/item/list', params);
}

// 获取排班详情
export const scheduleInfo = (schedulingItemId) => {
  return req.get(`/scheduling/item/${schedulingItemId}`);
}

// 获取义诊排班列表
export const scheduleFreeList = (params) => {
  return req.get('/scheduling/item/free/list', params);
}

// 义诊放号时间设置
export const scheduleFreeTime = (params) => {
  return req.post('/scheduling/item/free', params);
}

// 取消义诊
export const freeCancel = (schedulingItemIds) => {
  return req.post(`/scheduling/item/cancelFree/${schedulingItemIds}`);
}

// 自动排班
export const automaticScheduling = (params) => {
  return req.post('/scheduling/item/automaticScheduling', params);
}

// 删除排班
export const delScheduling = (params) => {
  return req.post('/scheduling/item/remove', params)
}

//获取排班规则
export const getTimeRule = (params) => {
  return req.get('/scheduling/timeQuantum/getTimeRule', params)
}

//获取排班下时间段
export const getTimeQuantumList = (params) => {
  return req.get('/scheduling/timeQuantum/getTimeQuantumList', params)
}

// ================(2025-06)排班重构接口===================
export const getScheduleRule = (params) => {
  return req.get('/aggregation-rule/select-rule', params)
}

export const setScheduleRule = (params) => {
  return req.post('/aggregation-rule/commit-rule', params)
}

export const deleteScheduleRule = (params) => {
  return req.delete('/aggregation-rule/delete-rule', params)
}

export const getScheduleMap = (params) => {
  return req.get('/aggregation-pb/map', params)
}

export const postDefaultScheduleList = (params) => {
  return req.post('/scheduling-item-new/create-list', params)
}

export const putDefaultScheduleList = (params) => {
  return req.put('/scheduling-item-new/update-list', params)
}

export const putDefaultScheduleOne = (params) => {
  return req.put('/scheduling-item-new/update-one', params)
}

export const deleteCheckSchedule = (params) => {
  return req.get(`/scheduling-item-new/delete-one/check`, params)
}

export const deleteDefaultSchedule = (params) => {
  return req.delete(`/scheduling-item-new/delete-one/${params.id}`, params)
}

export const postPhysioScheduleList = (params) => {
  return req.post('/scheduling-item-physical/create-list', params)
}

export const putPhysioScheduleList = (params) => {
  return req.put('/scheduling-item-physical/update-list', params)
}

export const putPhysioScheduleOne = (params) => {
  return req.put('/scheduling-item-physical/update-one', params)
}

export const deletePhysioSchedule = (params) => {
  return req.delete(`/scheduling-item-physical/delete-one/${params.id}`, params)
}

export const startStopSchedule = (params) => {
  return req.put(`/scheduling-suspend-medical/rule-stop/${params.id}`, params)
}

export const cancelStopSchedule = (params) => {
  return req.put(`/scheduling-suspend-medical/rule-cancel/${params.id}`, params)
}

export const batchStopSchedule = (params) => {
  return req.post('/scheduling-suspend-medical/rule-create', params)
}

export const getDoctorScheduleHistory = (params) => {
  return req.get('/aggregation-pb/exist', params)
}

export const getScheduleSuspendList = (params) => {
  return req.get('/scheduling-suspend-medical/rule-select', params)
}

export const deleteScheduleSuspend = (params) => {
  return req.delete(`/scheduling-suspend-medical/rule-delete/${params.id}`, params)
}

export const getDayAllotBedNumber = (params) => {
  return req.post(`/scheduling-item-physical/scheduling/selectDayAllotBedNumber`, params)
}

export const getWeekAllotBedNumber = (params) => {
  return req.post(`/scheduling-item-physical/scheduling/selectWeekAllotBedNumber`, params)
}

// 获取医生本月应坐诊次数
export const getDoctorMonthAllotBedNumber = (params) => {
  return req.get(`/aggregation-pb/visit-count`, params)
}